const profileData = {
name: "Anurag kumar",
role: "Full Stack Developer",
email: "anuragk06469@gmail.com",
skills: ["React", "Node.js", "MongoDB", "C#","Java","DSA"],
experience: [
    { company: "leaf corp", role: "Developer", years: "2022-2024" },
{ company: "leaf Ltd", role: "Intern", years: "2021-2022" }
],
education: [
{ degree: "B.Tech CSE-Ai", college: "Abdul kalam technical University,lucknow", year: "2023-27" }
]
};
export default profileData;
